import React, { Component } from 'react';

import classes from './StepFive.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import CheckBox from '../../../../UI/CheckBox/CheckBox';
import Input from '../../../../UI/Input/Input';
import InputError from '../../../../UI/InputError/InputError';
import config from '../../../../../constants/config';
import AlertError from '../../../AlertError/AlertError';
import Spinner from '../../../../UI/Spinner/Spinner';
import { isSafari, isIOS, isChrome } from 'react-device-detect';

export default class StepFive extends Component {
  constructor(props) {
    super(props);
    this.textEmailInput = React.createRef();
    this.textPasswordInput = React.createRef();
    this.state = {
      showEmailError: false,
      showPasswordError: false,
      showAlert: false,
      errorMessage: '',
      email: '',
      emailDirty: false, // used as ref when email field is touched by user
      password: '',
    };
  }

  timer = null;

  componentDidMount() {
    // console.log('STEP 5 DID MOUNT::::', this.props, this.state);

    if (this.props.email === '') {
      this.textEmailInput.focus();
    } else {
      this.setState({ email: this.props.email });
    }

    if (this.props.password) {
      this.setState({ password: this.props.password });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('STEP 5 NEXT PROPS::::', nextProps, this.props);

    if (
      nextProps.emailRegister.status === 'fail' &&
      nextProps.emailRegister.status !== this.props.emailRegister.status
    ) {
      this._toggleAlertError(nextProps.emailRegister.error.error);
    } else if (
      nextProps.emailLogin.status === 'fail' &&
      nextProps.emailLogin.status !== this.props.emailLogin.status
    ) {
      this._toggleAlertError(nextProps.emailLogin.error.error);
    }

    if (
      nextProps.transCoregLookup.status === 'success' &&
      nextProps.transCoregLookup.status !==
        this.props.transCoregLookup.status &&
      nextProps.transCoregLookup.response.exists
    ) {
      // console.log('SHOW TRANSCOREG CHECKBOX', nextProps);
      const { display_text, display_text_gdpr } =
        nextProps.transCoregLookup.response;
      const text = this._checkIfConsentRequired()
        ? display_text_gdpr
        : display_text;
      this.props.setTransCoreg(true, text);
      if (!this.props.isLandscape && ((isSafari && isIOS) || isChrome)) {
        this.props.toggleMinHeight();
      }
    }

    this.setState({ email: nextProps.email, password: nextProps.password });
  }

  _checkIfConsentRequired = () => {
    const { getConfig } = this.props;
    return getConfig.response && getConfig.response.show_cookie_consent;
  };

  _checkForTransCoreg = () => {
    const { getConfig } = this.props;
    return (
      getConfig.response &&
      getConfig.response.trans_coreg &&
      getConfig.response.trans_coreg.enabled
    );
  };

  _onEmailChange = (e) => {
    this.setState({ email: e.target.value });
    this.props.setEmail(e.target.value);
  };

  _onPasswordChange = (e) => {
    // console.log('PASSWORD CHANGE', e.target.value);

    const {
      target: { value },
    } = e;
    this.setState({ password: value });
    this.props.setPassword(value);

    const passwordLength = value.length;
    if (passwordLength >= 6) {
      this.setState({ showPasswordError: false });
    }
  };

  _renderEmailError = () => {
    const validEmail = this._validateEmail(this.state.email);
    const emailDirty = this.state.emailDirty;
    return (
      <InputError
        style={{ display: !validEmail && emailDirty ? 'block' : 'none' }}
      >
        {strings.emailError}
      </InputError>
    );
  };

  _renderPasswordError = () => {
    return (
      <InputError
        style={{ display: this.state.showPasswordError ? 'block' : 'none' }}
      >
        {strings.passwordError}
      </InputError>
    );
  };

  _validateEmail = () => {
    return config.EMAIL_REGEX.test(this.state.email);
  };

  _validatePassword = () => {
    return this.state.password.length >= 6;
  };

  _validateEmailAndPassword = () => {
    return this._validateEmail() && this._validatePassword();
  };

  _toggleAlertError = (errorMessage) => {
    this.setState({ showAlert: !this.state.showAlert, errorMessage });
  };

  _createAccount = () => {
    this.props.setPassword(this.state.password);
    this.props.createAccount();
  };

  _renderButton = () => {
    return (
      <Button
        disabled={!this._validateEmailAndPassword()}
        clicked={this._createAccount}
      >
        {strings.createAccount}
      </Button>
    );
  };

  _renderSpinner = () => {
    return (
      <div className={classes.SpinnerWrapper}>
        <Spinner size='Tiny' />
      </div>
    );
  };

  _onEmailKeyPress = (e) => {
    if (e.charCode === 13) {
      this.props.onBlur();
      this.textPasswordInput.focus();
    }
  };

  _onEmailBlur = () => {
    this.setState({ emailDirty: true });

    if (this.state.password) {
      this.props.setPassword(this.state.password);
    }

    this.props.onBlur();

    if (!this._validateEmail()) {
      this.setState({ showEmailError: true });
    } else if (
      this.props.email &&
      !this.props.showTransCoregCheckbox &&
      this._checkForTransCoreg() &&
      !this.props.transCoregLookup.isFetching
    ) {
      this.props.getTransCoreg(this.props.email, this.props.country);
    }
  };

  _onPasswordBlur = () => {
    if (this.state.email) {
      this.props.setEmail(this.state.email);
    }

    this.props.onBlur();
    if (!this._validatePassword()) {
      this.setState({ showPasswordError: true });
    }
  };

  _renderTransRegCheckbox = () => {
    if (this.props.showTransCoregCheckbox) {
      return (
        <div className={classes.CrossRegWrapper}>
          <CheckBox
            customCheckbox
            labelStyles={{
              marginLeft: '0.3rem',
              textAlign: 'left',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
            checked={this.props.isTransCoregOfferChecked}
            onClick={this.props.toggleTransCoregOffer}
          >
            <span
              style={{
                fontSize: this.props.isLandscape ? '0.85rem' : '0.6875rem',
                color: 'var(--urlLink-text-color)',
              }}
              className={classes.Html}
              dangerouslySetInnerHTML={{ __html: this.props.transCoregText }}
            />
          </CheckBox>
        </div>
      );
    }
  };

  render() {
    // console.log('STEP 5 RENDER:', this.props, this.state, config);

    const { email, password } = this.props;
    const inputLabelStyle = {
      fontSize: '0.8125rem',
      fontWeight: 'var(--font-weight-normal)',
      textAlign: 'left',
      paddingTop: '0',
      width: '100%',
      marginBottom: '0.5rem',
    };

    return (
      <div className={classes.StepFive}>
        <div className={classes.InputWrapper}>
          <Input
            style={{ height: '2.5rem', minHeight: '2.5rem' }}
            setRef={(component) => {
              this.textEmailInput = component;
            }}
            type='email'
            inputMode='email'
            autoCapitalize='off'
            autoCorrect='off'
            autoComplete='email'
            value={this.state.email || email}
            onBlur={this._onEmailBlur}
            onChange={this._onEmailChange}
            label={`${strings.EnterYourEmailAddress} ${strings.RemainsConfidential}:`}
            inputLabelStyle={inputLabelStyle}
            onKeyPress={this._onEmailKeyPress}
            placeholder={strings.EnterEmailAddress}
            maxLength={128}
          />
          {this._renderEmailError()}
          <Input
            setRef={(component) => {
              this.textPasswordInput = component;
            }}
            type='password'
            value={this.state.password || password}
            onFocus={this.props.onFocus}
            onBlur={this._onPasswordBlur}
            onChange={this._onPasswordChange}
            label={`${strings.ChooseAPassword} ${strings.Min6Car}:`}
            inputLabelStyle={inputLabelStyle}
            placeholder={strings.EnterPassword}
            maxLength={128}
          />
          {this._renderPasswordError()}
          <div className={classes.Footer}>
            {this._renderTransRegCheckbox()}
            {this.props.emailRegister.isFetching ||
            this.props.emailLogin.isFetching
              ? this._renderSpinner()
              : this._renderButton()}
          </div>
        </div>
        {this.state.showAlert ? (
          <AlertError
            dismissAlert={this._toggleAlertError}
            errorMessage={this.state.errorMessage}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegisterInner/Steps/StepFive/StepFive.js